import { useCallback } from 'react';

export const useUpdateLocationInfo = () => {
	const updateLocationInfo = useCallback((prevState, frame) => {
		const location = { ...prevState.location };
		location.lat = frame.trackPosition[1];
		location.lon = frame.trackPosition[0];
		location.hdg = frame.heading;
		return location;
	}, []);

	return { updateLocationInfo };
};
